{
  "FILTER": {
    "TITLE": "대화 필터링하기",
    "SUBTITLE": "아래에 필터를 추가하고 '필터 적용'을 클릭하여 대화를 정리하십시오.",
    "EDIT_CUSTOM_FILTER": "폴더 편집",
    "CUSTOM_VIEWS_SUBTITLE": "필터를 추가 또는 제거하고 폴더를 업데이트하십시오.",
    "ADD_NEW_FILTER": "필터 추가",
    "FILTER_DELETE_ERROR": "필터를 저장하려면 최소한 하나의 필터를 추가하십시오.",
    "SUBMIT_BUTTON_LABEL": "필터 적용하기",
    "UPDATE_BUTTON_LABEL": "폴더 업데이트",
    "CANCEL_BUTTON_LABEL": "취소",
    "CLEAR_BUTTON_LABEL": "필터 초기화",
    "FOLDER_LABEL": "폴더 이름",
    "FOLDER_QUERY_LABEL": "폴더 쿼리",
    "EMPTY_VALUE_ERROR": "값이 필요합니다.",
    "TOOLTIP_LABEL": "대화 필터링하기",
    "QUERY_DROPDOWN_LABELS": {
      "AND": "와/과",
      "OR": "혹은"
    },
    "INPUT_PLACEHOLDER": "값을 입력하십시오",
    "OPERATOR_LABELS": {
      "equal_to": "동일한",
      "not_equal_to": "비동일한",
      "does_not_contain": "포함되지 않은",
      "is_present": "현존하는",
      "is_not_present": "현존하지 않은",
      "is_greater_than": "보다 큰",
      "is_less_than": "보다 작은",
      "days_before": "x 일 전에",
      "starts_with": "시작하는",
      "equalTo": "동일한",
      "notEqualTo": "비동일한",
      "contains": "포함된",
      "doesNotContain": "포함되지 않은",
      "isPresent": "현존하는",
      "isNotPresent": "현존하지 않은",
      "isGreaterThan": "보다 큰",
      "isLessThan": "보다 작은",
      "daysBefore": "x 일 전에",
      "startsWith": "시작하는"
    },
    "ATTRIBUTE_LABELS": {
      "TRUE": "참",
      "FALSE": "거짓"
    },
    "ATTRIBUTES": {
      "STATUS": "상태",
      "ASSIGNEE_NAME": "담당자 이름",
      "INBOX_NAME": "받은 메시지함 이름",
      "TEAM_NAME": "팀 이름",
      "CONVERSATION_IDENTIFIER": "대화 식별자",
      "CAMPAIGN_NAME": "캠페인 이름",
      "LABELS": "라벨",
      "BROWSER_LANGUAGE": "브라우저 언어",
      "PRIORITY": "우선순위",
      "COUNTRY_NAME": "국가 이름",
      "REFERER_LINK": "참고 링크",
      "CUSTOM_ATTRIBUTE_LIST": "리스트",
      "CUSTOM_ATTRIBUTE_TEXT": "텍스트",
      "CUSTOM_ATTRIBUTE_NUMBER": "숫자",
      "CUSTOM_ATTRIBUTE_LINK": "링크",
      "CUSTOM_ATTRIBUTE_CHECKBOX": "체크박스",
      "CREATED_AT": "생성 일시",
      "LAST_ACTIVITY": "최근 활동"
    },
    "ERRORS": {
      "VALUE_REQUIRED": "값이 필요합니다.",
      "ATTRIBUTE_KEY_REQUIRED": "속성 키가 필요합니다.",
      "FILTER_OPERATOR_REQUIRED": "필터 연산자가 필요합니다.",
      "VALUE_MUST_BE_BETWEEN_1_AND_998": "값은 1에서 998 사이여야 합니다."
    },
    "GROUPS": {
      "STANDARD_FILTERS": "기본 필터",
      "ADDITIONAL_FILTERS": "추가 필터",
      "CUSTOM_ATTRIBUTES": "사용자 정의 속성"
    },
    "CUSTOM_VIEWS": {
      "ADD": {
        "TITLE": "이 필터를 저장하시겠습니까?",
        "LABEL": "필터 이름 지정하기",
        "PLACEHOLDER": "나중에 참조할 수 있도록 필터 이름을 지정하십시오.",
        "ERROR_MESSAGE": "이름이 필요합니다.",
        "SAVE_BUTTON": "필터 저장하기",
        "CANCEL_BUTTON": "취소",
        "API_FOLDERS": {
          "SUCCESS_MESSAGE": "폴더가 성공적으로 생성되었습니다.",
          "ERROR_MESSAGE": "폴더 생성 중 오류가 발생했습니다."
        },
        "API_SEGMENTS": {
          "SUCCESS_MESSAGE": "세그먼트가 성공적으로 생성되었습니다.",
          "ERROR_MESSAGE": "세그먼트 생성 중 오류가 발생했습니다."
        }
      },
      "EDIT": {
        "EDIT_BUTTON": "폴더 편집"
      },
      "DELETE": {
        "DELETE_BUTTON": "필터 삭제하기",
        "MODAL": {
          "CONFIRM": {
            "TITLE": "삭제 확인",
            "MESSAGE": "정말로 이 필터를 삭제하시겠습니까? ",
            "YES": "예, 삭제합니다",
            "NO": "아니요, 유지합니다"
          }
        },
        "API_FOLDERS": {
          "SUCCESS_MESSAGE": "폴더가 성공적으로 삭제되었습니다.",
          "ERROR_MESSAGE": "폴더 삭제 중 오류가 발생했습니다."
        },
        "API_SEGMENTS": {
          "SUCCESS_MESSAGE": "세그먼트가 성공적으로 삭제되었습니다.",
          "ERROR_MESSAGE": "세그먼트 삭제 중 오류가 발생했습니다."
        }
      }
    }
  }
}
